import { render, staticRenderFns } from "./ShoppingCartThankYou.vue?vue&type=template&id=81ac4334"
import script from "./ShoppingCartThankYou.ts?vue&type=script&lang=ts&external"
export * from "./ShoppingCartThankYou.ts?vue&type=script&lang=ts&external"
import style0 from "./ShoppingCartThankYou.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports